module.exports = __webpack_public_path__ + "static/media/pengumuman.c162900b.svg";